import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EventCard = ({ event, onShare }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatTime = (timeString) => {
    return new Date(`2000-01-01T${timeString}`)?.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getEventTypeColor = (type) => {
    const colors = {
      'workshop': 'bg-blue-100 text-blue-800',
      'promocao': 'bg-green-100 text-green-800',
      'evento': 'bg-purple-100 text-purple-800',
      'feira': 'bg-orange-100 text-orange-800',
      'palestra': 'bg-indigo-100 text-indigo-800'
    };
    return colors?.[type] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-card rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300 overflow-hidden group">
      <div className="relative overflow-hidden h-48">
        {/* Background Image */}
        <Image
          src={event?.image}
          alt={event?.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        
        {/* Instagram-style Logo Circle with Name */}
        <div className="absolute top-3 left-3 z-10 flex items-center space-x-2">
          <div className="w-10 h-10 rounded-full bg-background border-2 border-background shadow-lg overflow-hidden flex items-center justify-center">
            {event?.organizerLogo ? (
              <Image
                src={event.organizerLogo}
                alt={event?.organizer || 'Organizador'}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <Icon name="Calendar" size={20} className="text-white" />
              </div>
            )}
          </div>
          {event?.organizer && (
            <div className="bg-background/90 backdrop-blur-sm rounded-full px-3 py-1.5 shadow-lg">
              <span className="text-xs font-semibold text-foreground">
                {event.organizer}
              </span>
            </div>
          )}
        </div>

        {/* Event Type Badge */}
        <div className="absolute top-3 right-3">
          <span className={`px-3 py-1 rounded-full text-xs font-medium backdrop-blur-sm bg-background/80 ${getEventTypeColor(event?.type)}`}>
            {event?.type?.charAt(0)?.toUpperCase() + event?.type?.slice(1)}
          </span>
        </div>
        
        {event?.featured && (
          <div className="absolute top-14 right-3">
            <div className="bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium backdrop-blur-sm">
              Destaque
            </div>
          </div>
        )}
        
        {/* Date and Time Info */}
        <div className="absolute bottom-4 left-4 bg-background/90 backdrop-blur-sm rounded-lg px-3 py-2">
          <div className="text-sm font-semibold text-foreground">
            {formatDate(event?.date)}
          </div>
          <div className="text-xs text-muted-foreground">
            {formatTime(event?.startTime)} - {formatTime(event?.endTime)}
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-heading font-semibold text-foreground line-clamp-2 flex-1">
            {event?.title}
          </h3>
          <button
            onClick={() => onShare(event)}
            className="ml-2 p-2 text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors duration-200"
            aria-label="Compartilhar evento"
          >
            <Icon name="Share2" size={16} />
          </button>
        </div>

        <p className="text-muted-foreground text-sm mb-4 line-clamp-3">
          {event?.description}
        </p>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} className="mr-2" />
            <span>{event?.location}</span>
          </div>
          
          {event?.organizer && (
            <div className="flex items-center text-sm text-muted-foreground">
              <Icon name="User" size={14} className="mr-2" />
              <span>{event?.organizer}</span>
            </div>
          )}

        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            {event?.tags && event?.tags?.slice(0, 2)?.map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;